// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2MMgb","header":"MessagesList_header__1vMTo","chat":"MessagesList_chat__3oPsN"};